// Impression des tickets de caisse.
// - Dans l'application SogoGestion Desktop : le ticket est imprimé
//   automatiquement, sans boîte de dialogue, sur l'imprimante « tickets »
//   choisie dans le menu de l'application (différente de celle des étiquettes).
// - Dans un navigateur normal (ou pour un document A4 comme une facture) :
//   le PDF s'ouvre dans un nouvel onglet, comme avant.
import { PDFJS_SRC, PDFJS_WORKER_SRC, loadScript } from "./depotLabelPrint";
import { toast } from "sonner";

const MAX_TICKET_WIDTH_MM = 100; // au-delà : document A4 (facture...), pas un ticket thermique

async function renderPdfPage(pdfUrl) {
  await loadScript(PDFJS_SRC);
  if (!window.pdfjsLib) throw new Error("Lecteur PDF indisponible");
  window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
  const resp = await fetch(pdfUrl, { credentials: "include" });
  if (!resp.ok) throw new Error("Ticket introuvable");
  const pdf = await window.pdfjsLib.getDocument({ data: await resp.arrayBuffer() }).promise;
  const page = await pdf.getPage(1);
  const base = page.getViewport({ scale: 1 }); // en points (1/72 pouce)
  const widthMm = (base.width * 25.4) / 72;
  const heightMm = (base.height * 25.4) / 72;
  if (widthMm > MAX_TICKET_WIDTH_MM) return { widthMm, heightMm, dataUrl: null };
  const viewport = page.getViewport({ scale: 3 }); // ~216 dpi : net sur une imprimante thermique 203 dpi
  const canvas = document.createElement("canvas");
  canvas.width = Math.ceil(viewport.width);
  canvas.height = Math.ceil(viewport.height);
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  await page.render({ canvasContext: ctx, viewport }).promise;
  return { widthMm, heightMm, dataUrl: canvas.toDataURL("image/png") };
}

// Imprime (ou ouvre) le PDF d'un document de caisse. `pdfUrl` = URL complète.
export async function printTicketPdf(pdfUrl) {
  if (!window.SogoDesktop?.printImage) {
    window.open(pdfUrl, "_blank");
    return;
  }
  const t = toast.loading("Impression du ticket...");
  try {
    const { widthMm, heightMm, dataUrl } = await renderPdfPage(pdfUrl);
    if (!dataUrl) { // document A4 : on l'affiche, l'imprimante de tickets n'est pas adaptée
      toast.dismiss(t);
      window.open(pdfUrl, "_blank");
      return;
    }
    const res = await window.SogoDesktop.printImage(dataUrl, widthMm, heightMm, "ticket");
    if (res?.ok) toast.success("Ticket envoyé à l'imprimante", { id: t });
    else toast.error(res?.error || "Échec de l'impression du ticket", { id: t });
  } catch (e) {
    // Repli : ouverture classique du PDF, pour ne jamais bloquer la vente.
    toast.error((e && e.message) || "Impression automatique impossible — ouverture du PDF", { id: t });
    window.open(pdfUrl, "_blank");
  }
}
